import { END_POINTS } from "../constants/url";
import {
  Customer,
  CustomerBody,
  CustomerDocs,
  Property,
  SubAdmin,
  SubAdminResponse,
} from "../types/General";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  statusCode: number;
  message: string;
};

export const customerApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomers: builder.query<
      CommonResponseType & {
        data: {
          list: Customer[] & SubAdminResponse[];
          totalCount: number;
          totalPages: number;
        };
      },
      {
        page: number;
        limit: number;
        search: string;
        role: number;
        status?: number;
      }
    >({
      query: ({ page, limit, search, role, status }) => ({
        url: `${END_POINTS.customer}?page=${page}&limit=${limit}&role=${role}${
          search?.length ? `&search=${search}` : ""
        }${status ? `&status=${status}` : ""}`,
        method: "GET",
      }),
    }),
    addCustomer: builder.mutation<
      CommonResponseType & { data: Customer & SubAdmin },
      CustomerBody
    >({
      query: (body) => ({
        url: END_POINTS.customer,
        method: "POST",
        body,
      }),
    }),
    updateStatusCustomer: builder.mutation<
      CommonResponseType & { data: Customer & SubAdmin },
      {
        isBlocked: boolean;
        userId: string;
      }
    >({
      query: (body) => ({
        url: `${END_POINTS.customer}`,
        method: "PUT",
        body,
      }),
    }),

    updateCustomer: builder.mutation<
      CommonResponseType & { data: Customer & SubAdmin },
      Partial<CustomerBody>
    >({
      query: (body) => ({
        url: `${END_POINTS.customer}`,
        method: "PUT",
        body,
      }),
    }),

    // addDocs: builder.mutation<
    //   CommonResponseType & { data: Customer },
    //   { documents: CustomerDocs[] }
    // >({
    //   query: (body) => ({
    //     url: `${END_POINTS.customer}`,
    //     method: "PUT",
    //     body,
    //   }),
    // }),

    getCustomerById: builder.query<
      CommonResponseType & { data: Customer & SubAdminResponse },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.customer}/${id}`, 
        method: "GET",
      }),
    }),
    customerExport: builder.query<CommonResponseType & { data: string }, {page:number; limit:number; status: number; search: string; role:number}>({
      query: ({page,limit,status,search,role}) => ({
        url: `${END_POINTS.customer}/exportCsvUser?page=${page}&limit=${limit}&status=${status}&search=${search}&role=${role}`,
        method: "GET",
      }),
    }),
    deleteCustomer: builder.query<CommonResponseType, { userId: string }>({
      query: (body) => ({
        url: `${END_POINTS.customer}`,
        method: "DELETE",
        body,
      }),
    }),

    //property
    addProperty: builder.mutation<
      CommonResponseType & { data: Property },
      Property
    >({
      query: (body) => ({
        url: END_POINTS.propertydetail,
        method: "POST",
        body,
      }),
    }),

    updateProperty: builder.mutation<
      CommonResponseType & { data: Property },
      Property
    >({
      query: (body) => ({
        url: END_POINTS.propertydetail,
        method: "PUT",
        body,
      }),
    }),

    getProperty: builder.query<
      CommonResponseType & {
        data: { list: Property[]; totalCount: number; totalPages: number };
      },
      {
        page: number;
        limit: number;
        search: string;
        role: number;
        userId: string | undefined;
      }
    >({
      query: ({ page, limit, search, role, userId }) => ({
        url: `${END_POINTS.propertydetail}?userId=${userId}`,
        method: "GET",
      }),
    }),
    deleteProperty: builder.query<CommonResponseType, { propertyId: string }>({
      query: (body) => ({
        url: `${END_POINTS.propertydetail}`,
        method: "DELETE",
        body,
      }),
    }),
      
  }),
});
export const {
  useLazyGetCustomersQuery,
  useAddCustomerMutation,
  useUpdateCustomerMutation,
  useUpdateStatusCustomerMutation,
  useLazyDeleteCustomerQuery,
  useLazyGetCustomerByIdQuery,
  // useAddDocsMutation,
  useAddPropertyMutation,
  useLazyGetPropertyQuery,
  useLazyDeletePropertyQuery,
  useUpdatePropertyMutation,
  useLazyCustomerExportQuery,
} = customerApi;
